import React from 'react';

class RowItemQLNNKNTC extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.soVanBanBanHanhMoi}</td>
        <td className='txt-center'>{data.soVanBanDuaSuaDoiBoSung}</td>
        <td className='txt-center'>{data.phapLuatVeKNTCLop}</td>
        <td className='txt-center'>{data.phapLuatVeKNTCNguoi}</td>
        <td className='txt-center'>{data.thucHienPLVeKNTCSoCuoc}</td>
        <td className='txt-center'>{data.thucHienPLVeKNTCSoDonVi}</td>
        <td className='txt-center'>{data.soDonViCoViPham}</td>
        <td className='txt-center'>{data.kienNghiXuLyKiemDiemRutKNToChuc}</td>
        <td className='txt-center'>{data.kienNghiXuLyKiemDiemRutKNCaNhan}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhToChuc}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhCaNhan}</td>
        <td className='txt-center'>{data.tongSoKLTTVaQDXLDaKiemDiem}</td>
        <td className='txt-center'>{data.ketQuaKTDaKiemDiemRutKNToChuc}</td>
        <td className='txt-center'>{data.ketQuaKTDaKiemDiemRutKNCaNhan}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhToChuc}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhCaNhan}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemQLNNKNTC;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemQLNNKNTC.jsx